import { ContractType, ContractStatus, ContractModificationStatus } from "../constants/dealer-basic-data";
import { ContractLine } from "./contract-line.model";
import { ContractModification } from "./contract-modification.model";

export class Contract {

    contractId: string = "";

    type: ContractType = ContractType.MANAGEMENT;

    customerId: string = "";
    providerId: string = "";

    title: string = "";
    description: string = "";

    status: ContractStatus = ContractStatus.DRAFT;

    createdBy: string = ""; 
    created: string = ""; 
    lastUpdated: string = ""; 

    modifications: ContractModification [] = [];  
    lines: ContractLine [] = [];  

    constructor(){
        
        this.modifications = [];
        this.lines = [];
    }

    public getActiveNonCarModificationId(): number{

        let modification: ContractModification = this.modifications.find( modif => !modif.type.startsWith('CAR') && modif.status == ContractModificationStatus.PROPOSED ) !
        
        return modification == undefined ? -1 : modification.id;
    }
 }